module.exports = __webpack_public_path__ + "img/ybzdywjg_charact_3.cf003573.svg";